// This is the entry point for the home component
import React, { FC, useCallback } from 'react';
import injectSheet from 'react-jss';
import CheckBox from 'Components/CheckBox';
import withErrorBoundary from 'HOC/ErrorBoundary';
import styleSheet from './styles';

interface Props {
  classes: any;
  callback?: any;
  relativeEngagement?: any;
}

const RelativeEngagement: FC<Props> = ({
  classes,
  callback,
  relativeEngagement,
}: Props) => {
  return (
    <div className={classes.checkBoxWrapper}>
      <div className={classes.paddingBottom}>
        <CheckBox
          label="High"
          id="high"
          overrideStyles={{ checkedColor: '#079DC0' }}
          value={relativeEngagement.high}
          isChecked={relativeEngagement.high}
          onClick={useCallback(callback, [relativeEngagement])}
        />
      </div>
      <div className={classes.paddingBottom}>
        <CheckBox
          label="Medium"
          id="medium"
          overrideStyles={{ checkedColor: '#079DC0' }}
          value={relativeEngagement.medium}
          isChecked={relativeEngagement.medium}
          onClick={useCallback(callback, [relativeEngagement])}
        />
      </div>
      <div>
        <CheckBox
          label="Low"
          id="low"
          overrideStyles={{ checkedColor: '#079DC0' }}
          value={relativeEngagement.low}
          isChecked={relativeEngagement.low}
          onClick={useCallback(callback, [relativeEngagement])}
        />
      </div>
    </div>
  );
};

RelativeEngagement.defaultProps = {
  callback: () => {},
  relativeEngagement: {},
};
export default withErrorBoundary(injectSheet(styleSheet)(RelativeEngagement));
